import React from "react"
import PropTypes from "prop-types"
import { Link as GatsbyLink } from "gatsby"
import clsx from "clsx"

import {
  AppBar,
  Toolbar,
  Box,
  Link,
  makeStyles,
  useTheme,
  Drawer,
} from "@material-ui/core"
import { Menu } from "@material-ui/icons"

import efficientAccountingLogo from "../images/logo.png"
import logoMobileNav from "../images/logo-mobile-nav.png"
import colors from "../utility/colors"
import Hero from "./hero"
import NavMobile from "./nav-mobile"

const useStyles = makeStyles(theme => ({
  appBar: {
    position: "relative",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    zIndex: "1",
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.6)",
    padding: "0 100px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 20px",
    },
  },
  nav__item: {
    margin: `0 25px`,
    fontSize: "15px",
    listStyle: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  nav__link: {
    fontWeight: 500,
    "&:hover": {
      textDecoration: "none",
      color: colors.green[900],
    },
    "&:active": {
      color: colors.green[400],
    },
  },
  nav__phone: {
    textDecoration: "underline",
  },
  activeLink: {
    color: colors.grey[300],
  },
}))

const Header = props => {
  const classes = useStyles()
  const { data } = props
  const theme = useTheme()
  const [open, setOpen] = React.useState(false)

  const toggleDrawer = open => {
    setOpen(open)
  }

  return (
    <>
      <AppBar className={classes.appBar} position="static">
        <Toolbar className={classes.toolbar}>
          <Box display={{ xs: "none", md: "block" }}>
            <Link component={GatsbyLink} to="/">
              <img src={efficientAccountingLogo} alt="Efficient Accounting" />
            </Link>
          </Box>
          <Box display={{ md: "none" }}>
            <Link component={GatsbyLink} to="/">
              <img src={logoMobileNav} alt="Efficient Accounting" />
            </Link>
          </Box>
          <Box component="nav" display={{ xs: "none", md: "block" }}>
            <Box component="ul" display="flex" ml={1}>
              <li className={classes.nav__item}>
                <Link
                  className={classes.nav__link}
                  activeClassName={classes.activeLink}
                  component={GatsbyLink}
                  to="/about"
                >
                  ABOUT
                </Link>
              </li>
              <li className={classes.nav__item}>
                <Link
                  className={clsx(classes.nav__link, classes.nav__phone)}
                  href={theme.data.phoneHref}
                >
                  {theme.data.uiPhone}
                </Link>
              </li>
            </Box>
          </Box>
          <Box display={{ md: "none" }}>
            <Menu color="primary" onClick={() => toggleDrawer(true)} />
          </Box>
        </Toolbar>
        <Hero
          classes={{ bgImage: data.pageName, containerText: data.pageName }}
          isIndex={data.isIndex}
          imgName={data.imgName}
          title={data.title}
          subtitle={data.subtitle}
          primaryBtnLabel={data.primaryBtnLabel}
          primaryBtnHref={data.primaryBtnHref}
          secondaryBtnLabel={data.secondaryBtnLabel}
          secondaryBtnHref={data.secondaryBtnHref}
        ></Hero>
      </AppBar>
      <Drawer open={open} anchor="right" onClose={() => toggleDrawer(false)}>
        <NavMobile />
      </Drawer>
    </>
  )
}

Header.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Header
